<section>
    <ng-container *ngIf="exportMap; else create">

        <div class="message">
            <h3>Below is a summary of your Export Map</h3>
            <p class="font-light">Download the Export Map to continue working on it. When you're done, you can save it by importing it back with the link above.</p>
        </div>

        <div class="row stats">
            <div class="col-md-4 stat">
                <strong>{{exportMap?.propertyComponents?.length}}</strong>
                <span>Total Property {{ 'Components' | terminology | async }}</span>
            </div>
            <div class="col-md-4 stat">
                <strong>{{exportMap?.mappedPropertyComponents?.length}}</strong>
                <span>Mapped {{ 'Components' | terminology | async }}</span>
            </div>
            <div class="col-md-4 stat">
                <strong [ngClass]="{'error' : exportMap?.unmappedPropertyComponents?.length !== 0}">{{exportMap?.unmappedPropertyComponents?.length}}</strong>
                <span>Unmapped {{ 'Components' | terminology | async }}</span>
            </div>
        </div>
    </ng-container>

    <ng-template #create>
        <div class="row top-buffer-20">
            <div class="col-md-12">
                <sp-no-results-found
                    [message]="'No export map found'"
                    [suggestion]="'To get started, click Generate New Export Map above. Once created, you can import it using the Import Export Map link.'">
                </sp-no-results-found>
            </div>
        </div>
    </ng-template>
</section>
